import React from "react";

const OriginTrace = ({ trace, onChangeImage }) => {
  return <div className="container-trace">{trace ? <img alt="" src={trace}></img> : <div></div>}</div>;
};

export default OriginTrace;
